import React from "react";
import { Link } from "react-router-dom";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import List from "../../Misc/List";

export default class ElementOperation extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      items: [],
      operating: 0,
      customListKey: "",
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  loadReferences = async () => {};

  load = async () => {
    const { elementId } = this.props;
    this.setState({ pending: true });

    let items = await this.context.api.qa("/element/operating/time/list", {
      filter: { element: elementId },
      orderby: ["validtodate DESC"],
      reclimit: 1,
    });

    let item = items[0] || {};

    this.setState({
      items,
      item,
      operating: 0,
      customListKey: this.context.key(),
      pending: false,
    });
  };

  onOperatingChange = (value) => {
    this.setState({ operating: value });
  };

  onAdd = async () => {
    const { elementId } = this.props;
    const { item, operating } = this.state;
    this.setState({ pending: true });

    let current = item.value || 0;
    let value = parseInt(current) + parseInt(operating);

    let result = await this.context.api.qa("/element/operating/time/set", {
      element: elementId,
      value,
      type: 0,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { pending, operating, item } = this.state;
    const { brief, shipId, specId, elementId } = this.props;

    const OperationItem = (props) => {
      let from = new Date(props.validfromdate) || {};
      return (
        <>
          <div className="col-lg-6 pb-2 mb-2 border-bottom text-muted ">
            <i className="fa fa-calendar"></i> {from.toLocaleString()}
          </div>
          <div className="col-lg-6 pb-2 mb-2 border-bottom">
            {props.value} ч.
          </div>
        </>
      );
    };

    const current = (
      <div className="alert alert-light">
        <span className="text-muted">Текущая наработка:</span> {item.value || 0}{" "}
        ч.
      </div>
    );

    if (brief) {
      return (
        <Link to={`/element/${shipId}/${specId}/${elementId}/operation/`}>
          {current}
        </Link>
      );
    }

    return (
      <>
        <Blocker on={pending}>
          <div className="flex-grow-1">{current}</div>
          {!this.props.brief && (
            <React.Fragment>
              <div className="d-flex mt-3 mb-3 pb-3 border-bottom">
                <input
                  className="flex-grow-1 form-control"
                  type="number"
                  min="0"
                  step="1"
                  value={operating}
                  onChange={(e) => this.onOperatingChange(e.target.value)}
                />
                <button onClick={this.onAdd} className="btn btn-light ml-2">
                  Добавить
                </button>
              </div>

              <List
                listKey="ProductList"
                key={this.state.customListKey}
                search={JSON.stringify([
                  {
                    field: "element",
                    compare: "EQL",
                    value: this.props.elementId,
                  },
                ])}
                sort={JSON.stringify(["validtodate DESC"])}
                fields={""}
                limit={15}
                hideSinglePageNav={true}
                keyField="id"
                path="/element/operating/time/list"
                row={true}
                blocker={{ spinnerFixed: true, hAuto: true }}
                notFoundItem={<></>}
              >
                <OperationItem />
              </List>
            </React.Fragment>
          )}
        </Blocker>
      </>
    );
  }
}
